// extracted by mini-css-extract-plugin
module.exports = {"container":"_1yScM","img":"_2QRR5","title":"CC6pT","desc":"_1TOwF"};